var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      class: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-${this.color}-100 text-${this.color}-800`,
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }